export const requiredAssetsToAssetMap = (requiredAssets) =>
    requiredAssets.keys().reduce((assets: any, filename: string) => {
        const key = filename.replace(/^\.\//, '').replace(/\..*$/, '');
        assets[key] = requiredAssets(filename).default || requiredAssets(filename);

        return assets;
    }, {});
